import React from 'react'
import Svg, { Path, type PathProps, type SvgProps } from 'react-native-svg'
import { mesaColorNames } from '@/src/common/theme'

export const CardBenefitsOutlined = ({
  svgProps,
  pathProps,
  outlineColor,
  size = 32,
}: {
  svgProps?: SvgProps
  pathProps?: PathProps
  outlineColor?: string
  size?: number
}) => (
  <Svg width={size} height={size} viewBox="0 0 25 24" fill="none" {...svgProps}>
    <Path
      d="M7.50001 19.9998H17.5M7.21068 7.35518L6.28887 6.89428C5.55182 6.52575 4.71037 7.15684 4.85778 7.96759L6.05213 14.5365C6.31149 15.963 7.55388 16.9998 9.00374 16.9998H15.9963C17.4461 16.9998 18.6885 15.963 18.9479 14.5365L20.1422 7.96759C20.2897 7.15684 19.4482 6.52575 18.7112 6.89428L17.7893 7.35518C17.0194 7.74017 16.0894 7.58926 15.4807 6.98054L13.2071 4.70696C12.8166 4.31643 12.1834 4.31643 11.7929 4.70696L9.51932 6.98054C8.9106 7.58926 7.98066 7.74017 7.21068 7.35518ZM13 11.4998C13 11.776 12.7762 11.9998 12.5 11.9998C12.2239 11.9998 12 11.776 12 11.4998C12 11.2237 12.2239 10.9998 12.5 10.9998C12.7762 10.9998 13 11.2237 13 11.4998Z"
      stroke={outlineColor ?? mesaColorNames['Greyscale/400 #A4AAAC']}
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...pathProps}
    />
  </Svg>
)
